module.exports = __webpack_public_path__ + "img/cbc.b72e287.png";